import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindows as fabFaWindows } from '@fortawesome/free-brands-svg-icons';

import { fetchProduct } from 'Redux/ducks/product';
import AddToCartBtn from 'Components/Cards/AddToCartBtn';
import ProductCover from 'Components/Utility/ProductCover';
import Price from 'Containers/Utility/Price/Price';
import Drm from 'Components/Utility/Drm';
import useViewport from 'Hooks/useViewport';

import 'Components/Order/MysteryBuyAgain/MysteryBuyAgain.scss';

const messages = defineMessages({
  add_to_cart: {
    id: 'mystery-buy-again.button.add-to-cart',
    defaultMessage: 'Add to cart',
  },
  add: {
    id: 'mystery-buy-again.button.add',
    defaultMessage: 'Add',
  },
});

const MysteryBuyAgain = ({ item, intl }) => {
  const [mysteryBundle, setMysteryBundle] = useState(null);

  const { formatMessage } = intl;

  const { isBelowMd } = useViewport();

  // Details from order item
  const productId = get(item, '_id', '');
  const slug = get(item, 'slug', '');
  const tierIndex = get(item, 'bundles', []).length - 1;

  // Details from product
  const name = get(mysteryBundle, 'name', '');
  const cover = get(mysteryBundle, 'cover', '');
  const displayType = get(mysteryBundle, 'display_type', '');
  const coverType = get(mysteryBundle, 'cover_type', null);
  const soldOut = get(mysteryBundle, 'sold_out', false);
  const bundles = get(mysteryBundle, 'bundles', []);
  const drm = get(mysteryBundle, 'drm_string', '');

  const tierPurchased = bundles[tierIndex];

  const price = get(tierPurchased, 'price', {});

  useEffect(() => {
    const loadProduct = async () => {
      if (!slug) return false;

      return fetchProduct(slug)
        .then((result) => {
          if (result.notFound) return false;
          return setMysteryBundle(result.product);
        });
    };

    loadProduct();
  }, [slug]);

  if (!mysteryBundle || soldOut) return false;

  return (
    <div className="MysteryBuyAgain">
      <div className="MysteryBuyAgain__title">
        <FormattedMessage
          id="mystery-buy-again.title"
          defaultMessage="There’s more games to find in the {name}. Why not order again!"
          values={{ name: item.name }}
        />
      </div>
      <div className="MysteryBuyAgain__card">
        <div className="MysteryBuyAgain__card__cover">
          <ProductCover
            hitcard
            cover={cover}
            alt={`Product cover for ${name}`}
            displayType={displayType}
            coverType={coverType}
          />
        </div>
        <div className="MysteryBuyAgain__card__details">
          <div className="MysteryBuyAgain__card__details__nameIcons">
            <div className="MysteryBuyAgain__card__details__nameIcons__name">
              {name}
            </div>
            <div className="MysteryBuyAgain__card__details__nameIcons__icons">
              <div className="MysteryBuyAgain__card__details__nameIcons__icons__drm">
                <Drm drmType={drm} />
              </div>
              <div className="MysteryBuyAgain__card__details__nameIcons__icons__os">
                <FontAwesomeIcon icon={fabFaWindows} />
              </div>
            </div>
          </div>
          <div className="MysteryBuyAgain__card__details__priceButtons">
            <div className="MysteryBuyAgain__card__details__priceButtons__price">
              <Price price={price} />
            </div>
            <div className="MysteryBuyAgain__card__details__priceButtons__button">
              <AddToCartBtn
                hideIcon
                showInCartLink
                id={productId}
                slug={slug}
                tierIndex={tierIndex}
                buttonText={
                  isBelowMd ? formatMessage(messages.add) : formatMessage(messages.add_to_cart)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MysteryBuyAgain.propTypes = {
  item: PropTypes.object,
};

MysteryBuyAgain.defaultProps = {
  item: {},
};

export default injectIntl(MysteryBuyAgain);
